function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#150C78",
  rx: 2.462
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M19.632 14.675l.362.123-.014-.002c-.4-.08-6.723-1.308-14.768-.558 0 0 6.58-2.145 14.42.437zm-7.257-4.425v1.8s-.063.487.488.487h.437V10.65s.05-.275-.225-.275v-.113h.975v1.075h.925v-.762s.037-.237-.237-.237v-.088h.962v2.5h-.75s.038-.238.038-.387v-.738H14v.8s-.012.162.025.325c0 0-.713.063-1.162.063-.45 0-1.25.012-1.25-.963v-1.137s.024-.363-.213-.363v-.1h.975zm-3.662.012v2.525h-.725v-2.125c0-.337-.238-.312-.238-.312v-.088h.963zM5.138 10l.65 1.475.6-1.463h.837l.288 2.75h-.825L6.5 10.637l-.938 2.138h-.075l-.925-2.1-.2 2.075H4l.263-2.338c.037-.35-.226-.312-.226-.312V10h1.1zm6.162.25v.088l-1.275 2.112h1.35v.325H9.037v-.088l1.25-2.124H9.45c-.224 0-.258.128-.262.185v.027h-.075v-.525H11.3zm6.125-.05c.813 0 1.475.575 1.475 1.288 0 .712-.662 1.287-1.475 1.287-.813 0-1.475-.575-1.475-1.287 0-.713.663-1.288 1.475-1.288zm0 .325c-.413 0-.75.45-.75 1s.337 1 .75 1c.412 0 .738-.45.738-1s-.326-1-.738-1z"
}));

var SvgIcMb = function SvgIcMb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    style: {
      background: "#fff"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcMb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_mb.1d9f479e.svg";
export { ForwardRef as ReactComponent };